import groupBy from 'lodash.groupby';

export default groupBy;
